<template>
  <Header />
  <RevisionBrowser title="Revisions" />
</template>

<script>
import Header from './Header.vue';
import RevisionBrowser from './RevisionBrowser.vue';

export default {
  name: 'ViewRevisions',
  components: {
    Header,
    RevisionBrowser,
  },
};
</script>
